(function () {
    'use strict';

    angular
        .module('core.filters')
        .filter('document', FormatDocument)

    function FormatDocument() {
        return input => {
            let string = input + '';

            if (string.length == 9)
                return string.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3-$4');

            if (string.length == 11)
                return string.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');

            if (string.length == 14)
                return string.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');

            return string;
        }
    }
}());